import {useSelector} from 'react-redux'

/**
 * Custom React Hook to get count value from state.
 * @see https://reactjs.org/docs/hooks-custom.html
 */
const useCityAliasAPI = () => useSelector(state => state.cityAlias)

export default useCityAliasAPI


